$(document).on('turbolinks:load', () => {
  $('#search_btn').on('click', () => {
    $('.dataSearch').toggle();
  });
});
